import {AfterViewInit, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {Router} from '@angular/router';
import {SharedValueService} from '../../services/shared-value.service';
import {EventService} from '../../services/event.service';
import {Observable, Subscription} from 'rxjs/Rx';
import {DialogService} from '../../services/dialog.service';
import {EventDetailSetting} from '../../models/event-detail-setting';
import {UserSetting} from '../../models/user-setting';
import {Helper} from '../../common/helper';

@Component({
  selector: 'app-left-sidemenu',
  templateUrl: './left-sidemenu.component.html',
  styleUrls: ['./left-sidemenu.component.scss'],
  preserveWhitespaces: false
})
export class LeftSidemenuComponent implements OnInit, AfterViewInit, OnDestroy {

  userSession: UserSetting;
  private retryTime = 500;
  newEventsList = [];
  timerSubscription: Subscription;
  recentEventsSubscription: Subscription;
  newEventSubscription: Subscription;
  initial = true;
  avatarSubscription: Subscription;
  avatarUser: string;

  constructor(private auth: AuthenticationService,
              private router: Router,
              private sharedValueService: SharedValueService,
              private eventService: EventService,
              private ngZone: NgZone,
              private dialog: DialogService,
              private changeDetectorRef: ChangeDetectorRef,
              private helper: Helper) {
    this.avatarSubscription = sharedValueService.getAvatar().subscribe(avatar => {
      this.avatarUser = avatar;
    });
    this.helper._unsubsribe(this.newEventSubscription);
    this.newEventSubscription = this.sharedValueService.getNewEvent().subscribe(event => {
      this.getRecentEvents();
    });
  }

  ngOnInit() {
    this.userSession = this.sharedValueService.getUserSession();
    if (! this.userSession) {
      setTimeout(() => {
        this.ngOnInit();
      }, this.retryTime);
      return;
    } else {
      this.avatarUser = this.userSession.avatar;
    }
  }

  ngAfterViewInit() {
    this.getRecentEvents();
    this.helper._unsubsribe(this.timerSubscription);
    // run every 3 minutes to get newest events
    this.ngZone.runOutsideAngular(() => {
      this.timerSubscription = Observable.timer(0, 180000).subscribe(i => {
        if (this.auth.isLogin() && !this.initial) {
          this.getRecentEvents();
        }
      });
    });
  }

  ngOnDestroy() {
    this.helper._unsubsribe(this.timerSubscription);
    this.helper._unsubsribe(this.avatarSubscription);
    this.helper._unsubsribe(this.recentEventsSubscription);
  }

  getRecentEvents() {
    this.helper._unsubsribe(this.recentEventsSubscription);
    this.recentEventsSubscription = this.eventService.getNewEvents().subscribe(list => {
      this.newEventsList = list.data;
      this.initial = false;
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  eventDetail(event: EventDetailSetting) {
    if (event) {
      event['eventId'] = event.id;
      const obj = {
        eventModel: event,
        isDetail: true
      };
      this.dialog.showEventModal('Event Info', null, null, null, null, 'Close', obj)
        .subscribe();
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/layouts/left-sidemenu/left-sidemenu.component.ts